/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  NotificationPreferenceDto,
  UpdateNotificationPreferencesRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeNotificationsV1Response200 = {
  data: NotificationPreferenceDto[]
  status: 200
}

export type getMeNotificationsV1Response401 = {
  data: void
  status: 401
}

export type getMeNotificationsV1ResponseSuccess = (getMeNotificationsV1Response200) & {
  headers: Headers;
};
export type getMeNotificationsV1ResponseError = (getMeNotificationsV1Response401) & {
  headers: Headers;
};

export type getMeNotificationsV1Response = (getMeNotificationsV1ResponseSuccess | getMeNotificationsV1ResponseError)

export const getGetMeNotificationsV1Url = () => {




  return `/api/v1/me/notifications`
}

/**
 * Returns all notification preference toggles for the authenticated user.
 * @summary Get current user's notification preferences
 */
export const getMeNotificationsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeNotificationsV1Response> => {

  return customFetch<getMeNotificationsV1Response>(getGetMeNotificationsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type updateMeNotificationsV1Response200 = {
  data: NotificationPreferenceDto[]
  status: 200
}

export type updateMeNotificationsV1Response400 = {
  data: void
  status: 400
}

export type updateMeNotificationsV1Response401 = {
  data: void
  status: 401
}

export type updateMeNotificationsV1ResponseSuccess = (updateMeNotificationsV1Response200) & {
  headers: Headers;
};
export type updateMeNotificationsV1ResponseError = (updateMeNotificationsV1Response400 | updateMeNotificationsV1Response401) & {
  headers: Headers;
};

export type updateMeNotificationsV1Response = (updateMeNotificationsV1ResponseSuccess | updateMeNotificationsV1ResponseError)

export const getUpdateMeNotificationsV1Url = () => {




  return `/api/v1/me/notifications`
}

/**
 * Creates or updates the enabled/disabled state for one or more notification types in a single batch. Returns the resulting preferences.
 * @summary Update enabled state for one or more notification types
 */
export const updateMeNotificationsV1 = async (updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMeNotificationsV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMeNotificationsV1Response>(getUpdateMeNotificationsV1Url(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateNotificationPreferencesRequest)
  }
);}


